import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { GetRegisteredPlayerTableData } from '@/modules/manage-player/type'
import RegisteredPlayerTable from '../RegisteredPlayerTable'
import NavigateBackButton from '@/common/components/NavigateBackButton'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'

type SortOrder = 'asc' | 'desc' | undefined
interface RegisteredPlayerListingProps {
	data: GetRegisteredPlayerTableData[]
	total: number
	isLoading?: boolean
	onSort?: (columnId: string, order: SortOrder) => void
}

export default function RegisteredPlayerListing({
	data,
	total,
	isLoading,
	onSort: parentOnSort,
}: RegisteredPlayerListingProps) {
	const handleSort = (columnId: string, order: SortOrder) => {
		if (columnId === 'createdAt' || columnId === 'totalDepositAmount') {
			parentOnSort?.(columnId, order)
		}
	}
	return (
		<div className="space-y-4">
			<NavigateBackButton />
			<div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
				<Heading
					title={`สมาชิกสมัครใหม่`}
					description="รายการสมาชิกสมัครใหม่"
				/>
				<div className="flex flex-col gap-2 sm:items-end">
					<DateRangePicker />
					<DateRangeButtons />
				</div>
			</div>
			<Separator />
			<RegisteredPlayerTable
				data={data}
				total={total}
				isLoading={isLoading}
				onSort={handleSort}
			/>
		</div>
	)
}
